"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.extractIsCompleted = exports.dateRangeToClipboardText = exports.dateToClipboardText = exports.getChoicesToAdd = exports.getChoicesIntersection = exports.clipboardCreatedUpdatedToChoice = exports.serializeClipboardCreatedUpdated = exports.trimAndLower = exports.findChoiceValuesByLabels = exports.findChoiceValueByText = exports.processClipboardEmailTextValueWithSeparators = exports.processClipboardTextValueWithSeparators = void 0;
const email_validation_1 = require("@smartsuite/email-validation");
const types_1 = require("@smartsuite/types");
const date_1 = require("../formatters/date");
function processClipboardTextValueWithSeparators(clipboardValue, separators = types_1.textSeparators) {
    const splitRegEx = new RegExp(`[${separators}]+`);
    return clipboardValue.text
        .trim()
        .split(splitRegEx)
        .map((value) => value.replace(/\r?\n/g, ""))
        .map((val) => val.trim())
        .filter((val) => !!val);
}
exports.processClipboardTextValueWithSeparators = processClipboardTextValueWithSeparators;
function processClipboardEmailTextValueWithSeparators(clipboardValue) {
    return clipboardValue.text
        .trim()
        .split((0, email_validation_1.getSplitEmailRegex)())
        .map((value) => value.replace(/\r?\n/g, ""))
        .map((val) => val.trim())
        .filter((val) => !!val);
}
exports.processClipboardEmailTextValueWithSeparators = processClipboardEmailTextValueWithSeparators;
/**
 * Tries to find among target field choices given text value.
 * Case insensitively.
 */
function findChoiceValueByText(targetField, text) {
    var _a;
    const choices = targetField.params.choices;
    const label = trimAndLower(text);
    const foundChoice = choices === null || choices === void 0 ? void 0 : choices.find((choice) => trimAndLower(choice.label) === label);
    return (_a = foundChoice === null || foundChoice === void 0 ? void 0 : foundChoice.value) !== null && _a !== void 0 ? _a : null;
}
exports.findChoiceValueByText = findChoiceValueByText;
/**
 * Tries to find given labels among target field choices.
 * Case insensitively.
 * Returns values in a same order as given labels.
 */
function findChoiceValuesByLabels(choices, labels) {
    if (labels.length === 0) {
        return [];
    }
    const labelsChoicesMap = choices.reduce((result, choice) => {
        const label = trimAndLower(choice.label);
        result.set(label, choice);
        return result;
    }, new Map());
    return labels
        .map((label) => { var _a; return (_a = labelsChoicesMap.get(trimAndLower(label))) === null || _a === void 0 ? void 0 : _a.value; })
        .filter((value) => !!value);
}
exports.findChoiceValuesByLabels = findChoiceValuesByLabels;
function trimAndLower(text) {
    return text.trim().toLowerCase();
}
exports.trimAndLower = trimAndLower;
function serializeClipboardCreatedUpdated(clipboardValue) {
    var _a, _b, _c;
    if ((_a = clipboardValue.rawValue) === null || _a === void 0 ? void 0 : _a.full_name.sys_root) {
        return (_c = (_b = clipboardValue.rawValue) === null || _b === void 0 ? void 0 : _b.full_name.sys_root) === null || _c === void 0 ? void 0 : _c.toLowerCase();
    }
    return undefined;
}
exports.serializeClipboardCreatedUpdated = serializeClipboardCreatedUpdated;
function clipboardCreatedUpdatedToChoice(clipboardValue, targetField) {
    var _a;
    const clipboardUserName = serializeClipboardCreatedUpdated(clipboardValue);
    return (_a = targetField.params.choices) === null || _a === void 0 ? void 0 : _a.find((choice) => choice.label.toLowerCase() === clipboardUserName);
}
exports.clipboardCreatedUpdatedToChoice = clipboardCreatedUpdatedToChoice;
function getChoicesIntersection(choices1, choices2) {
    return choices1.filter((choice) => choices2
        .map((choice2) => choice2.label.toLowerCase())
        .includes(choice.label.toLowerCase()));
}
exports.getChoicesIntersection = getChoicesIntersection;
function getChoicesToAdd(addFromChoices, addToChoices) {
    return addFromChoices.filter((choiceFrom) => !addToChoices
        .map((choiceTo) => choiceTo.label.toLowerCase())
        .includes(choiceFrom.label.toLowerCase()));
}
exports.getChoicesToAdd = getChoicesToAdd;
function dateToClipboardText(value, userPreferences, fieldDisplayFormat) {
    if (!(value === null || value === void 0 ? void 0 : value.date)) {
        return "";
    }
    const dateFieldValueFormatter = new date_1.DateFieldValueFormatter();
    const date = dateFieldValueFormatter.prepareDateValue(value.date, userPreferences, value.include_time);
    if (!date) {
        return "";
    }
    const formattedDate = dateFieldValueFormatter.formatDate(date, userPreferences, fieldDisplayFormat, userPreferences.locale.date_format, true);
    if (value.include_time) {
        const formattedTime = dateFieldValueFormatter.formatTime(date, userPreferences);
        return `${formattedDate} ${formattedTime}`;
    }
    return formattedDate;
}
exports.dateToClipboardText = dateToClipboardText;
function dateRangeToClipboardText(value, userPreferences, fieldDisplayFormat) {
    var _a;
    if (!((_a = value === null || value === void 0 ? void 0 : value.to_date) === null || _a === void 0 ? void 0 : _a.date)) {
        return "";
    }
    const displayFormat = fieldDisplayFormat === "pill" ? "standard" : fieldDisplayFormat;
    const fromDateText = dateToClipboardText(value === null || value === void 0 ? void 0 : value.from_date, userPreferences, displayFormat);
    const toDateText = dateToClipboardText(value === null || value === void 0 ? void 0 : value.to_date, userPreferences, displayFormat);
    if (fromDateText) {
        return `${fromDateText} – ${toDateText}`;
    }
    return toDateText;
}
exports.dateRangeToClipboardText = dateRangeToClipboardText;
function isItemCompleted(item) {
    const itemStatus = item.toLocaleLowerCase();
    return itemStatus === "checked" || itemStatus === "true";
}
function extractIsCompleted(checkListItem) {
    if (!checkListItem) {
        return {
            completed: false,
            completed_at: "",
        };
    }
    // look for anything inside parenthesis but outside html tags
    const stringsBetweenParenthesis = checkListItem.match(/\(([^)]*)(?=\))(?![^<]*>|[^<>]*<\/)/g);
    if (!stringsBetweenParenthesis) {
        return {
            completed: false,
            completed_at: "",
        };
    }
    const lastMatch = stringsBetweenParenthesis[stringsBetweenParenthesis.length - 1].replace("(", "");
    const completed = isItemCompleted(lastMatch);
    return {
        completed,
        completed_at: completed ? new Date().toISOString() : "",
    };
}
exports.extractIsCompleted = extractIsCompleted;
